// src/components/analytics/components/tabs/MonthlyComparison.js
import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip as RechartsTooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';
import CustomTooltip from '../CustomTooltip';

const MonthlyComparison = ({ data }) => {
    const theme = useTheme();

    // Generate monthly comparison data for bar chart
    const getMonthlyComparison = () => {
        if (!data || data.length === 0) return [];
        return data.map(month => ({
            name: month.name,
            income: month.transactions,
            expenses: month.expenses,
            profit: month.transactions - month.expenses
        }));
    };

    return (
        <>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Monthly Income vs Expenses
            </Typography>
            <Box sx={{ height: 400 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={getMonthlyComparison()}
                        margin={{ top: 10, right: 30, left: 20, bottom: 70 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis
                            dataKey="name"
                            axisLine={false}
                            tickLine={false}
                            tick={{ fontSize: 12 }}
                            height={50}
                            angle={-45}
                            textAnchor="end"
                        />
                        <YAxis
                            axisLine={false}
                            tickLine={false}
                            tick={{ fontSize: 12 }}
                            tickFormatter={(value) => `${value / 1000}k`}
                        />
                        <RechartsTooltip content={<CustomTooltip />} />
                        <Legend
                            verticalAlign="top"
                            height={36}
                            iconType="circle"
                            iconSize={10}
                        />
                        <Bar
                            dataKey="income"
                            name="Income"
                            fill={theme.palette.success.main}
                            radius={[4, 4, 0, 0]}
                        />
                        <Bar
                            dataKey="expenses"
                            name="Expenses"
                            fill={theme.palette.error.main}
                            radius={[4, 4, 0, 0]}
                        />
                        <Bar
                            dataKey="profit"
                            name="Net Profit"
                            fill={theme.palette.primary.main}
                            radius={[4, 4, 0, 0]}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </Box>
        </>
    );
};

export default MonthlyComparison;